var map = {
	"./door-type.jpg": 9919,
	"./door.jpg": 9124,
	"./double-type.jpg": 6450,
	"./double-window.jpg": 2066,
	"./gallery.webp": 1852,
	"./height-frame.jpg": 3129,
	"./height-mesurement-frame.jpg": 6025,
	"./how-to-measure.jpg": 9559,
	"./other-type.jpg": 7355,
	"./other-window.jpg": 3007,
	"./pleats-frame-1.jpg": 6919,
	"./pleats-frame-2.jpg": 4600,
	"./pleats-frame-3.jpg": 2213,
	"./pleats-frame-4.jpg": 9326,
	"./pleats-frame-5.jpg": 9483,
	"./pleats-frame-6.jpg": 6684,
	"./pleats-frame-7.jpg": 825,
	"./pole-frame.jpg": 734,
	"./quadruple-type.jpg": 628,
	"./quadruple-window.jpg": 1108,
	"./single-type.jpg": 391,
	"./single-window.jpg": 1539,
	"./triple-type.jpg": 5507,
	"./triple-window.jpg": 8487,
	"./width-frame.jpg": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2766;